import axios from "axios";

// "Keep me signed in" desmarcado no login: a sessao vale so ate fechar o app ou a aba.
// Na primeira vez que o app abre, se essa marca existe e a sessao nova ainda nao
// foi aberta, o login antigo e apagado. Este codigo roda antes de qualquer tela.
try {
  if (localStorage.getItem("ss_keep") === "0" && !sessionStorage.getItem("ss_alive")) {
    localStorage.removeItem("ss_token");
    localStorage.removeItem("ss_keep");
  }
} catch (e) {
  // sem acesso ao armazenamento: segue normalmente
}

// Endereco do servidor. No APP DO IPHONE usamos sempre o servidor de producao: assim um build feito sem a
// variavel REACT_APP_BACKEND_URL (ou com uma errada) nao deixa o login quebrado. No site vale a variavel,
// e se ela faltar tambem cai no servidor de producao.
const PRODUCTION_URL = "https://webapp-sitesync.onrender.com";
export const runningInApp = (() => {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch (e) {
    return false;
  }
})();
const BACKEND_URL = runningInApp ? PRODUCTION_URL : process.env.REACT_APP_BACKEND_URL || PRODUCTION_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^http/, "ws");

// O login usa o token guardado no aparelho (cabecalho Authorization), nao cookie. No app do iPhone mandar
// cookies junto nao ajuda e pode fazer o navegador recusar a resposta do servidor (o servidor responde com
// "*", e isso nao e aceito quando o pedido leva cookies). No site continua como sempre.
const api = axios.create({ baseURL: API, withCredentials: !runningInApp });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Sem resposta nenhuma = nao deu para falar com o servidor (sem internet, servidor acordando, bloqueio).
    // Em vez de cada tela mostrar um texto generico ("Login failed"), todas passam a mostrar isto.
    if (err && !err.response && err.request && !axios.isCancel(err)) {
      err.isNetworkError = true;
      err.response = {
        status: 0,
        data: { detail: "Cannot reach the server. Check your internet connection and try again in a moment." },
      };
    }
    if (err?.response?.status === 401) {
      // token expired / missing — leave routing to AuthContext
    } else if (err?.response?.status === 403) {
      const detail = err.response.data?.detail;
      const code = detail && typeof detail === "object" ? detail.code : null;
      if (code === "COMPANY_PENDING" || code === "COMPANY_REJECTED") {
        if (typeof window !== "undefined" && window.location.pathname !== "/app/pending") {
          window.location.replace("/app/pending");
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail, fallback = "Something went wrong") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
